export const colors = {
  violet: '#7501D9',
  yellow: '#FFB245',
};

export const fonts = {
  primary: '"Archia", sans-serif',
  secondary: '"Euclid Circular B", Arial, sans-serif',
};
